import { Link } from 'react-router-dom';
import { journalEntries } from '@/utils/journalFeed';
import StepSection from './StepSection';

const trade = journalEntries[0];

const fields = [
  { label: 'ENTRY', value: trade.entry },
  { label: 'EXIT', value: trade.exit },
  { label: 'VOLUME', value: trade.volume },
  { label: 'DATE', value: trade.date },
];

function StepRecord() {
  return (
    <StepSection
      id="step-09"
      index="09"
      stage="record"
      title="Every Trade Becomes Data"
      subtitle="Once a trade is closed, the result becomes part of the trading record."
      body="Closed positions are logged with their entry, exit, volume and result, and can be reviewed through the Trade Journal."
      reverse
      band
    >
      <div className="rounded-lg border border-background-300 bg-background-50 p-5 md:p-6">
        <div className="rounded-lg border border-background-200 bg-background-100 p-5">
          <div className="flex items-center justify-between">
            <span className="font-data text-[13px] font-semibold text-foreground-950">
              {trade.instrument}
            </span>
            <span
              className={`px-2 py-0.5 rounded-md text-[10px] font-data tracking-wider ${
                trade.side === 'BUY'
                  ? 'bg-profit-500/10 text-profit-600'
                  : 'bg-loss-500/10 text-loss-500'
              }`}
            >
              {trade.side}
            </span>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-y-3 gap-x-6">
            {fields.map((field) => (
              <div key={field.label} className="flex items-center justify-between">
                <span className="text-[11px] text-foreground-500">{field.label}</span>
                <span className="font-data text-[12px] text-foreground-900">{field.value}</span>
              </div>
            ))}
          </div>

          <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between">
            <span className="text-[12px] text-foreground-500">RESULT</span>
            <span
              className={`font-data text-[20px] font-semibold ${
                trade.profit ? 'text-profit-600' : 'text-loss-500'
              }`}
            >
              {trade.result}
            </span>
          </div>
        </div>

        <Link
          to="/trade-journal"
          className="mt-5 inline-flex items-center gap-2 text-[14px] font-semibold text-primary-700 hover:text-primary-600 transition-colors cursor-pointer"
        >
          Explore Trade Journal
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>
    </StepSection>
  );
}

export default StepRecord;